import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { UiQnStatusBadgeComponent } from './ui-qn-status-badge/ui-qn-status-badge.component';
import { FlowQuestionnaireComponent } from './flow-questionnaire/flow-questionnaire.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatIconModule],
  declarations: [UiQnStatusBadgeComponent, FlowQuestionnaireComponent],
  exports: [UiQnStatusBadgeComponent, FlowQuestionnaireComponent]
})
export class SharedComponentsModule {}
